export default __webpack_public_path__ + "static/feature-flap-3b0da06cb47501617262574c9b4f2440.png";